var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, SupportMaterialCard } from "@sequentech/ui-essentials";
import { downloadBlob } from "@sequentech/ui-core";
import DescriptionIcon from "@mui/icons-material/Description";
import { useGetPublicDocumentUrl } from "../../hooks/public-document-url";
import { useAppSelector } from "../../store/hooks";
import { selectDocumentById } from "../../store/documents/documentsSlice";
export var SupportMaterial = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, kind = _a.kind, tenantId = _a.tenantId, documentId = _a.documentId, onViewed = _a.onViewed;
    var t = useTranslation().t;
    var _b = React.useState(false), openPreview = _b[0], openPreviewSet = _b[1];
    var getDocumentUrl = useGetPublicDocumentUrl().getDocumentUrl;
    var videoRef = React.useRef(null);
    var imageData = useAppSelector(selectDocumentById(String(documentId)));
    var handleOpenDialog = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            openPreviewSet(true);
            return [2 /*return*/];
        });
    }); };
    var documentName = imageData === null || imageData === void 0 ? void 0 : imageData.name;
    var documentUrl = documentName ? getDocumentUrl(documentId, documentName) : "";
    var handleDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, blob, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!documentUrl || !documentName) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch(documentUrl)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.blob()];
                case 3:
                    blob = _a.sent();
                    return [4 /*yield*/, downloadBlob(blob, documentName)];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error("Error downloading document:", error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(SupportMaterialCard, { title: title, subtitle: subtitle, kind: kind, onOpen: function () { return handleOpenDialog("video"); }, openLabel: t("a11y.previewMaterial", { title: title }) }), _jsx(Dialog, { className: "support-material-preview-dialog", variant: "info", open: openPreview, ok: t("materials.common.close"), title: t("materials.common.preview"), handleClose: function (result) {
                    openPreviewSet(false);
                    onViewed === null || onViewed === void 0 ? void 0 : onViewed();
                }, fullWidth: true, maxWidth: "lg", expandable: true, children: _jsx(Box, { className: "support-material-preview", sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        width: "100%",
                        height: "80vh",
                        justifyContent: "center",
                        alignItems: "center",
                    }, children: _jsx(Box, { className: "support-material-preview-content", sx: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                        }, children: kind.includes("image") ? (_jsx("img", { className: "support-material-image", src: documentUrl, alt: "tenant-".concat(tenantId, "/document-").concat(documentId, "/").concat(documentName), style: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" } })) : kind.includes("pdf") ? (_jsx(Box, { className: "support-material-pdf-container", sx: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                height: "100%",
                            }, children: _jsx("iframe", { className: "support-material-pdf", src: documentUrl, title: "".concat(t("materials.common.label"), " tenant-").concat(tenantId, "/document-").concat(documentId, "/").concat(documentName), width: "100%", height: "100%", style: { border: "none" } }) })) : kind.includes("video") ? (_jsx(Box, { className: "support-material-video-container", sx: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                height: "100%",
                            }, children: _jsx("iframe", { className: "support-material-video", ref: videoRef, width: "100%", height: "100%", src: documentUrl, title: "".concat(t("materials.common.label"), " tenant-").concat(tenantId, "/document-").concat(documentId, "/").concat(documentName), referrerPolicy: "origin", sandbox: "allow-scripts allow-same-origin", allow: "autoplay;", style: { border: "none" } }) })) : kind.includes("audio") ? (_jsx(Box, { className: "support-material-audio-container", sx: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                            }, children: _jsx("iframe", { className: "support-material-audio", loading: "lazy", width: "100%", height: "120", src: documentUrl, title: "".concat(t("materials.common.label"), " tenant-").concat(tenantId, "/document-").concat(documentId, "/").concat(documentName), allow: "autoplay", style: { border: "none" } }) })) : (_jsxs(Box, { className: "support-material-download-container", sx: {
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "16px",
                            }, children: [_jsx(DescriptionIcon, { className: "support-material-document-icon", sx: { fontSize: "5rem" } }), _jsx(Button, { className: "support-material-download-button", sx: { padding: "10px 24px", minWidth: "unset" }, variant: "secondary", onClick: handleDownload, children: t("materials.common.download") })] })) }) }) })] }));
};
